'use strict';

import { getLifeProjectDetail } from '../../api/getLifeProjectDetail';

import { Modal } from '@lf/mwuikit/src/scripts/objects/modal';
import { Tooltip } from '@lf/mwuikit/src/scripts/objects/tooltip';

(function () {

    const seeLifeProjectDetailCTAElements = document.querySelectorAll('button[data-project-life-detail-slug]');
    const videoElements = document.getElementsByClassName('cta--cigale-play-video-wrapper');

    const modal = Modal(
    {
        isAlignCenter: false,
        isLarger: true
    }
    );

    modal.init();

    if (videoElements) {
        for (let i = 0; i < videoElements.length; i++) {
            videoElements[i].addEventListener('click', function () {
                modal.show('<div class="video-iframe">' +
                    '<iframe width="560" height="315" src="' + videoElements[i].dataset.video + '" frameborder="0"' +
                    'allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"' +
                    'allowfullscreen></iframe>' +
                    '</div>');
            });
        }
    }

    for (let i = 0; i < seeLifeProjectDetailCTAElements.length; i++) {
        const ctaElement = seeLifeProjectDetailCTAElements[i];

        ctaElement.addEventListener('click', function (event) {
            getLifeProjectDetail(
            this.dataset.projectLifeDetailSlug.replace('#', ''),
            function (response) {
                modal.show(
                response,
                function () {
                    const tooltipCTAElements = modal.element.querySelectorAll('[data-tooltip-content]');
                    let tooltips = [];

                    if (tooltipCTAElements.length > 0) {
                    for (let i = 0; i < tooltipCTAElements.length; i++) {
                        const tooltip = Tooltip({
                        modal: modal.element,
                        zIndex: 1006
                        });
                        tooltip.init(tooltipCTAElements[i]);
                        tooltips.push(tooltip);
                    }

                    modal.element.addEventListener('click', function (event) {
                        event.stopPropagation();
                        for (let i = 0; i < tooltips.length; i++) {
                        const tooltip = tooltips[i];
                        if (tooltip.isShown) {
                            if (tooltip.ctaElement != event.target && tooltip.element != event.target && !tooltip.element.contains(event.target)) {
                            tooltip.hide();
                            }
                        }
                        }
                    });
                    }
                }
                );
            },
            function () {
            }
            );
        });
    }
}());
